import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseTenantStatementTemplates = [
  {
    id: '-224001',
    language: Language.EN,
    subject: 'Statement of charges',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>Your statement of charges is available here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-224002',
    language: Language.FR,
    subject: 'Décompte  de charges',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Votre décompte de charges est disponible ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-224003',
    language: Language.NL,
    subject: 'Afrekening van huurlasten',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Uw kostenoverzicht is hier beschikbaar: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-224004',
    language: Language.DE,
    subject: 'Nebenkostenabrechnung',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ihre Nebenkostenabrechnung ist hier verfügbar: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
